import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import {
  Requisition,
  RequisitionSearchRequest,
  RequisitionSearchResponse,
  ReviewRequestPayload,
} from "./@types";

export const requisitionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRequisitions: builder.mutation<
      ApiSuccessResponse<RequisitionSearchResponse>,
      RequisitionSearchRequest
    >({
      query: (data) => ({
        url: "/v1/requisition/search",
        method: "POST",
        body: { ...data },
      }),
    }),
    getReviewRequisitions: builder.mutation<
      ApiSuccessResponse<RequisitionSearchResponse>,
      RequisitionSearchRequest
    >({
      query: (data) => ({
        url: "/v1/requisition/approver/pending",
        method: "POST",
        body: { ...data },
      }),
    }),
    getApprovalHistoryRequisitions: builder.mutation<
      ApiSuccessResponse<RequisitionSearchResponse>,
      RequisitionSearchRequest
    >({
      query: (data) => ({
        url: "/v1/requisition/approver/processed",
        method: "POST",
        body: { ...data },
      }),
    }),
    approvalOrDeclineRequisitions: builder.mutation<void, ReviewRequestPayload>(
      {
        query: (data) => ({
          url: "/v1/requisition/approve-reject",
          method: "POST",
          body: { ...data },
        }),
      }
    ),
    createRequisition: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/v1/requisition",
        method: "POST",
        body: { ...data },
      }),
    }),
    updateRequisition: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: `/v1/requisition/update/${data.id}`,
        method: "PUT",
        body: { ...data },
      }),
    }),
    getRequisitionById: builder.query<ApiSuccessResponse<Requisition>, string>({
      query: (id) => ({
        url: `/v1/requisition/requisitions/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetRequisitionsMutation,
  useGetReviewRequisitionsMutation,
  useGetApprovalHistoryRequisitionsMutation,
  useApprovalOrDeclineRequisitionsMutation,
  useCreateRequisitionMutation,
  useUpdateRequisitionMutation,
  useGetRequisitionByIdQuery,
} = requisitionApiSlice;
